import React, { Component } from 'react';
import { Modal, Input } from 'antd';
import './AddFolderDialog.scss';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';

class AddFolderDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputVal: '',
        };
        this.input = React.createRef();
    }
    componentDidUpdate () {
        setTimeout(() => {
            this.autoFocus();
        }, 0);
    }
    
    handleOk () {
        const inputVal = this.state.inputVal.trim();
        if (store.storageAppStore.regExpName(inputVal)) return 
        const onConfirm = this.props.onConfirm;
        onConfirm && onConfirm(inputVal);
        this.setState({ inputVal: '' });        
    }
    onChange (data) {
        this.setState({
            inputVal: data.target.value
        });
    }
    doHide () {
        this.setState({ inputVal: '' });
        const onHide = this.props.onHide;
        onHide && onHide();
    }
    autoFocus () {
        if (!this.props.visible) return ;
        let input = this.input;
        if (!input || !input.current) return ;
        input = input.current.input;
        input && input.focus();
    }
    render () {
        const { inputVal } = this.state;
        return (
            <Modal className='add-folder-model' 
                title={intl.get('FoxitStorage.AddFolderDialog.Title')} 
                visible={this.props.visible} 
                okText={intl.get('FoxitStorage.Ok')}
                cancelText={intl.get('FoxitStorage.Cancel')}
                onOk={()=>this.handleOk()} 
                onCancel={()=>this.doHide()}
                okButtonProps={{ disabled: inputVal.length===0 }}>
                <div className='add-folder-main'>
                    <label>{intl.get('FoxitStorage.AddFolderDialog.EnterFolderName')}</label>
                    <div>
                        <Input ref={this.input} maxLength={200} value={inputVal} onChange={(e)=>this.onChange(e)} />
                    </div>
                </div>
            </Modal>
        );
    }
}
export default AddFolderDialog;
